import { FormattedMessage } from 'react-intl';
import {
  Anchor,
  AnchorButton,
  Box,
  Flex,
  Link,
  Loading,
  Text
} from '../../../components';
import { useCurrentUser } from '../../../lib/core/useCurrentUser';
import { AddOrReplacePaymentMethod } from '../../PaymentMethod/AddOrReplacePaymentMethod';
import { PaymentCard } from '../../PaymentMethod/PaymentCard';
import { RemovePaymentMethod } from '../../PaymentMethod/RemovePaymentMethod';
import { messages } from './messages';

export const PaymentMethods = () => {
  const { currentUser, loading } = useCurrentUser();

  if (loading) {
    return (
      <Flex justifyContent="center">
        <Loading />
      </Flex>
    );
  }

  const paymentMethod = currentUser?.paymentMethod;

  return (
    <>
      <Flex flexDirection="column" alignItems="center">
        {paymentMethod && (
          <Box mb="xs">
            <PaymentCard paymentMethod={paymentMethod} />
          </Box>
        )}
        <Flex flexDirection="column" alignItems="center" mb="xs">
          <AddOrReplacePaymentMethod>
            {({ onAddPaymentMethodClick, addOrReplacePaymentMethodUI }) => {
              return (
                <>
                  {!paymentMethod && (
                    <Text
                      as="p"
                      data-testid="StripePaymentMethods__noPaymentCardDescription"
                    >
                      <FormattedMessage
                        {...messages.noPaymentCardDescription}
                        values={{
                          // eslint-disable-next-line react/display-name
                          addlink: (...chunks) => (
                            <AnchorButton onClick={onAddPaymentMethodClick}>
                              {chunks}
                            </AnchorButton>
                          )
                        }}
                      />
                    </Text>
                  )}
                  {addOrReplacePaymentMethodUI}
                </>
              );
            }}
          </AddOrReplacePaymentMethod>
          {paymentMethod && (
            <RemovePaymentMethod paymentMethod={paymentMethod} />
          )}
        </Flex>
        <Text as="p">
          <FormattedMessage {...messages.paymentCardUsageDescription} />
        </Text>
        {paymentMethod &&
          paymentMethod.__typename === 'Card' &&
          paymentMethod.expired && (
            <Text as="p">
              <FormattedMessage {...messages.paymentCardExpiredDescription} />
            </Text>
          )}
      </Flex>

      <Text as="p">
        <FormattedMessage
          {...messages.receiptsLink}
          values={{
            // eslint-disable-next-line react/display-name
            receiptslink: (...chunks) => (
              <Link route="profile.receipts" passHref>
                <Anchor>{chunks}</Anchor>
              </Link>
            )
          }}
        />
      </Text>
    </>
  );
};
